<template>
  <div :style="{ height: pageSpace }"></div>

  <transition name="btn-top">
    <button
      v-show="show"
      type="button"
      class="btn-page-top"
      :class="btnClass"
      @click="toTop"
      :style="{
        position: position,
        backgroundColor: bgColor,
        height: `${size}px`,
        width: `${size}px`,
      }"
    >
      <svg viewBox="0 0 49.88 29">
        <path d="M4.11 29L25.01 8.14L45.86 29L49.94 24.95L25 0L25 0L0.06 24.95L4.11 29Z" :fill="color"></path>
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      required: false,
      default: "sticky",
    },
    btnClass: {
      type: String,
      required: false,
      default: null,
    },
    bgColor: {
      type: String,
      required: false,
      default: "#000",
    },
    color: {
      type: String,
      required: false,
      default: "#fff",
    },
    size: {
      type: Number,
      required: false,
      default: 70,
    },
    limit: {
      type: Number,
      required: false,
      default: 300,
    },
    pageSpace: {
      type: String,
      required: false,
      default: "0",
    },
    watchFor: {
      type: Number,
      required: false,
      default: null,
    },
    smoothScroller: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      scrollTop: window.scrollY,
      show: false,
    };
  },
  watch: {
    watchFor(value) {
      if (value > this.limit) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  methods: {
    toTop() {
      if (this.smoothScroller) {
        this.smoothScroller.scrollTo("top");
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    onScroll() {
      this.scrollTop = window.scrollY;

      if (this.scrollTop > this.limit) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (!this.watchFor) {
      window.addEventListener("scroll", this.onScroll, {
        passive: true,
      });
    }
  },
  destroyed() {
    if (!this.watchFor) {
      window.removeEventListener("scroll", this.onScroll);
    }
  },
};
</script>

<style lang="scss">
.btn-page-top {
  z-index: 20;
  left: calc(100% - 60px - 3%);
  bottom: calc(3vw + 30px);
  transform: translateY(50%);
  border-radius: 50%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
  transition: box-shadow 250ms ease-out;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
  }

  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0);
  }
}

.btn-top-enter-active,
.btn-top-leave-active {
  transition: all 250ms ease-out;
}

.btn-top-enter-from,
.btn-top-leave-to {
  opacity: 0;
}
</style>